import NoBook from '@assets/icons/no-book.svg'
import { Icon } from './Icon'

export const NoBookIcon = Icon(NoBook)
